import { render, staticRenderFns } from "./AskQuestion.vue?vue&type=template&id=654e3903&scoped=true"
import script from "./AskQuestion.vue?vue&type=script&lang=js"
export * from "./AskQuestion.vue?vue&type=script&lang=js"
import style0 from "./AskQuestion.vue?vue&type=style&index=0&id=654e3903&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654e3903",
  null
  
)

export default component.exports